module.exports = __webpack_public_path__ + "media/reflux esophagitis.eb321a23.wav";